export default __webpack_public_path__ + "static/media/primary-contact-icon.fea8e2fb.svg";